import { useState } from 'react'
import { IconButton, Spinner } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { BsDownload } from 'react-icons/bs'
import { downloadGeoXpExperience } from '../utils/helpers/supabase.helpers'
import { useGeneralToast } from '../hooks/toast'
import { downloadJson } from '../utils/helpers/download.helpers'

interface DownloadExpButtonProps {
  experienceId: string
}

const DownloadExpButton: React.FC<DownloadExpButtonProps> = ({ experienceId }) => {
  const { success, error } = useGeneralToast()

  const [downloading, setDownloading] = useState(false)

  const downloadExperience = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    setDownloading(true)

    const { data, error: err } = await downloadGeoXpExperience({ experienceId })

    if (err) {
      error('Error downloading experience')
      setDownloading(false)
      return
    }

    if (data) {
      await downloadJson({
        data: data as Record<string, unknown> | unknown[] | string | number | boolean | null,
        filename: `agami-exp-config-${experienceId}`,
      })
    }

    success('Experience downloaded successfully')

    setDownloading(false)
  }

  return (
    <IconButton size="sm" color={'primary' as colors} onClick={downloadExperience} disabled={downloading}>
      {downloading ? <Spinner className="h-4 w-4" /> : <BsDownload className="h-4 w-4" />}
    </IconButton>
  )
}

export default DownloadExpButton
